import React, { useState, useEffect, useContext } from "react";
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@material-ui/core";
import { TeacherApi, TeacherDto } from "../../api-clients/api";
import { getApiUrl } from "../../api-clients";
import Loading from "../Shared/Loading";
import NoResult from "../Shared/NoResult";
import { initializeIcons } from "@fluentui/react/lib/Icons";
import { useHistory } from "react-router-dom";
import { SearchBox } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { SchoolContext } from "../../contexts/SchoolContext";

initializeIcons();

export default function CardTeachers() {
  const { t } = useTranslation();
  const history = useHistory();
  const { teacherUpdated, setTeacherUpdated } = useContext(SchoolContext);
  const [teacherApi] = useState<TeacherApi>(new TeacherApi(getApiUrl()));
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [teachers, setTeachers] = useState<TeacherDto[]>([]);
  const [searchText, setSearchText] = useState<string>("");

  useEffect(() => {
    setIsLoading(true);
    setTeacherUpdated(false);
    teacherApi
      .getAll(true)
      .then((res) => {
        setTeachers(res);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, [teacherApi, teacherUpdated, setTeacherUpdated]);

  const filteredTeachers = teachers.filter((tch) =>
    `${tch.firstName ?? ""} ${tch.lastName ?? ""}`
      .toLowerCase()
      .includes(searchText.toLowerCase())
  );

  return (
    <Card>
      <CardHeader title={t("teachers.title")} />
      <CardContent>
        <Grid container spacing={1}>
          <Grid item sm={12} xs={12}>
            <SearchBox
              placeholder={t("teachers.searchPlaceholder")}
              value={searchText}
              onChange={(event, newValue) => setSearchText(newValue ?? "")}
              onClear={() => setSearchText("")}
            />
          </Grid>
        </Grid>
        {!isLoading ? (
          filteredTeachers.length > 0 ? (
            <List>
              {filteredTeachers.map((tch) => (
                <div key={tch.teacherId}>
                  <ListItem
                    button
                    alignItems="flex-start"
                    onClick={() => history.push("/teacher/" + tch.teacherId)}
                    style={{ paddingTop: "0px", paddingBottom: "0px" }}
                  >
                    {tch.firstName != null && tch.lastName != null && (
                      <ListItemAvatar>
                        <Avatar>
                          {tch.firstName[0]}
                          {tch.lastName[0]}
                        </Avatar>
                      </ListItemAvatar>
                    )}
                    <ListItemText
                      primary={`${tch.lastName ?? ""} ${tch.firstName ?? ""}`}
                      secondary={tch.email}
                    />
                  </ListItem>
                  <Divider />
                </div>
              ))}
            </List>
          ) : (
            <NoResult />
          )
        ) : (
          <Loading />
        )}
      </CardContent>
    </Card>
  );
}
